import React from 'react';

import PropTypes from 'prop-types';

import Pagination from '@/components/pagination/Pagination';

const PREVIOUS = 'PREVIOUS';
const NEXT = 'NEXT';

class VerticalNavigation extends React.PureComponent {
  chooseNavigationType = () => {
    const {onClick, totalPage, activePage} = this.props;
    const disableNavigator = totalPage <= 1;
    const paggingView = disableNavigator ? (
      <div className="pagging" />
    ) : (
      <Pagination
        id="pagination"
        total={totalPage}
        current={activePage}
      />
    );
    return (
      <div className="navigator">
        <button
          type="button"
          id={PREVIOUS}
          onClick={onClick}
          className="glyphicon glyphicon-menu-up buttonUp"
          disabled={disableNavigator}
        />
        <div className="center paggingView">{paggingView}</div>
        <button
          type="button"
          id={NEXT}
          onClick={onClick}
          className="glyphicon glyphicon-menu-down buttonDown"
          disabled={disableNavigator}
        />
      </div>
    );
  };

  render() {
    return this.chooseNavigationType();
  }
}
export default VerticalNavigation;

VerticalNavigation.Button = {
  PREVIOUS: 'PREVIOUS',
  NEXT: 'NEXT',
};

VerticalNavigation.Type = {
  BULETS: 'BULETS',
  BAR: 'BAR',
};

VerticalNavigation.propTypes = {
  onClick: PropTypes.func,
  totalPage: PropTypes.number,
  activePage: PropTypes.number,
};

VerticalNavigation.defaultProps = {
  onClick: () => {},
  totalPage: 0,
  activePage: 0,
};
